export default __webpack_public_path__ + "static/stayBrainYoung-9089b219ff668334339740304a522e44.png";